var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnalyticsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2871_20397",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2871_20397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15C10.1458 15 9.84896 15.1198 9.60938 15.3594C9.36979 15.599 9.25 15.8958 9.25 16.25V20C9.25 20.3542 9.36979 20.651 9.60938 20.8906C9.84896 21.1302 10.1458 21.25 10.5 21.25C10.8542 21.25 11.151 21.1302 11.3906 20.8906C11.6302 20.651 11.75 20.3542 11.75 20V16.25C11.75 15.8958 11.6302 15.599 11.3906 15.3594C11.151 15.1198 10.8542 15 10.5 15ZM20.5 8.75C20.1458 8.75 19.849 8.86979 19.6094 9.10938C19.3698 9.34896 19.25 9.64583 19.25 10V20C19.25 20.3542 19.3698 20.651 19.6094 20.8906C19.849 21.1302 20.1458 21.25 20.5 21.25C20.8542 21.25 21.151 21.1302 21.3906 20.8906C21.6302 20.651 21.75 20.3542 21.75 20V10C21.75 9.64583 21.6302 9.34896 21.3906 9.10938C21.151 8.86979 20.8542 8.75 20.5 8.75ZM15.5 17.5C15.1458 17.5 14.849 17.6198 14.6094 17.8594C14.3698 18.099 14.25 18.3958 14.25 18.75V20C14.25 20.3542 14.3698 20.651 14.6094 20.8906C14.849 21.1302 15.1458 21.25 15.5 21.25C15.8542 21.25 16.151 21.1302 16.3906 20.8906C16.6302 20.651 16.75 20.3542 16.75 20V18.75C16.75 18.3958 16.6302 18.099 16.3906 17.8594C16.151 17.6198 15.8542 17.5 15.5 17.5ZM6.75 26.25C6.0625 26.25 5.47396 26.0052 4.98438 25.5156C4.49479 25.026 4.25 24.4375 4.25 23.75V6.25C4.25 5.5625 4.49479 4.97396 4.98438 4.48438C5.47396 3.99479 6.0625 3.75 6.75 3.75H24.25C24.9375 3.75 25.526 3.99479 26.0156 4.48438C26.5052 4.97396 26.75 5.5625 26.75 6.25V23.75C26.75 24.4375 26.5052 25.026 26.0156 25.5156C25.526 26.0052 24.9375 26.25 24.25 26.25H6.75ZM15.5 15C15.8542 15 16.151 14.8802 16.3906 14.6406C16.6302 14.401 16.75 14.1042 16.75 13.75C16.75 13.3958 16.6302 13.099 16.3906 12.8594C16.151 12.6198 15.8542 12.5 15.5 12.5C15.1458 12.5 14.849 12.6198 14.6094 12.8594C14.3698 13.099 14.25 13.3958 14.25 13.75C14.25 14.1042 14.3698 14.401 14.6094 14.6406C14.849 14.8802 15.1458 15 15.5 15Z",
    fill: "#ADBBCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalyticsGrey);
export default __webpack_public_path__ + "static/media/icon_analytics_grey.887ca73c114bf473793275590fb32cb6.svg";
export { ForwardRef as ReactComponent };